export const isMatchStarted = (teamScores?: number[]) => {
  return teamScores?.some((score) => {
    return score > 0;
  });
};
